module.exports = __webpack_public_path__ + "img/Sleeves-Front-Gc-Ha-Ic.cf425239.png";